import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router'
import { activateGiftCardDetails } from 'ReduxStore/gift/Action';
import { Routes } from 'Utils';

interface RouteParams {
    token:string
}
const GiftCardActivated = () => {
    const params = useParams<RouteParams>();
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(activateGiftCardDetails(params.token));
    }, [])
    return (
        <section>
            <ConditionalCard
				information={`Email successfully confirmed.`}
				heading={`You have successfully confirmed your account`}
				conditions={[
					{
						id: 1,
						name: 'Login',
					},
				]}
				common = {{background:'#d4d4d4'}}
				onClick={() => history.push(Routes.Login)}
			/>
        </section>
    )
}

export default GiftCardActivated
